<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="inputMac" placeholder="请输入DID" prefix-icon="el-icon-search" size="small"></el-input>
				</el-form-item>
				<el-form-item>
				<el-date-picker v-model="picktime" size="small" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" @click="BeforeFind" icon="el-icon-search">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 100%" :max-height="maxHeight">
		    <el-table-column prop="did" label="设备DID" width="150"></el-table-column>
		    <el-table-column prop="info" label="设备状态明细"></el-table-column>
		    <el-table-column prop="time" label="更新时间" width="170" :formatter="dateFormat"></el-table-column>
  		</el-table>
  		
  		<!--工具条-->
  		<el-col :span="24" class="toolbar downtool">
			<el-pagination layout="prev, pager,next,jumper" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</div>
</template>

<script>
	import {GetDevWheelChairdataslist} from '../api/api';
	
	export default {
		data(){
			return {
				token:"",
				maxHeight:500,
				picktime:"",
				listloading:false,
				total:1,
				Curpage:1,
				Pagesize:20,
				List:[],
				inputMac:"",
				Screenall:{},
				Betweenall:{}
			}
		},
		beforeRouteLeave(to,from,next){
        	clearInterval(this.timer)
        	next()
        },
		methods:{
			handleCurrentChange(val){
				this.Curpage = val
				this.GetFind()
			},
			BeforeFind(){
				this.Curpage = 1
				this.GetFind()
			},
			GetFind(){
				if(this.picktime){
					this.Betweenall = {"BETWEEN":{'time':[this.picktime[0]/1000,this.picktime[1]/1000]}}
				}else{
					this.Betweenall = {"BETWEEN":{}}
				}
				if(this.inputMac){
					this.Screenall = {"AND":{'did':'~' + this.inputMac}}
				}else{
					this.Screenall = {"AND":{}}
				}
				var ever = [this.Screenall,this.Betweenall]
				var ever2 = JSON.stringify(ever)
				if(this.Screenall || this.Betweenall){
					this.GetList(GetDevWheelChairdataslist,{page:this.Curpage,token:this.token,fields:"id,info,did,time",sort:"-time",q:ever2})
				}else{
					this.GetList(GetDevWheelChairdataslist,{page:this.Curpage,token:this.token,fields:"id,info,did,time",sort:"-time"})
				}
			},
			Inloop(){
				this.GetFind()
			},
			Loop(){
				this.timer = setInterval(() => {this.Inloop()},30000)
			},
			Refresh(){
				this.picktime = ""
				this.inputMac = ""
				this.Curpage = 1
				this.GetList(GetDevWheelChairdataslist,{page:this.Curpage,token:this.token,fields:"id,info,did,time",sort:"-time"})
			}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetList(GetDevWheelChairdataslist,{page:this.Curpage,token:this.token,fields:"id,info,did,time",sort:"-time"})
			this.Loop()
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
		
	}

</script>

<style scoped>

</style>







// WEBPACK FOOTER //
// WheelChairMonitoring.vue?3b1d2096